"use client";

import React from "react";
import { Link } from "@/navigation";
import { FileText, EnvelopeSimple, House, WhatsappLogo } from "@phosphor-icons/react";
import { contactInfo } from "@/lib/contacts";

const WHATSAPP_URL = `https://wa.me/${contactInfo.whatsapp.replace(/\D/g, "")}`;

/** 桌面端：右侧竖向三个圆形按钮（询盘、邮箱、WhatsApp）；移动端：底部全宽栏（Home、Quote、Email、WhatsApp） */
export default function FloatingInquiryButtons() {
	const iconSize = 26;

	return (
		<>
			{/* 桌面端：右侧竖向三圆钮，仅 md 以上显示 */}
			<div className="fixed bottom-[20%] right-4 z-[9999] hidden flex-col gap-3 md:flex">
				{/* 询盘/报价 - 橙色，跳转 /upload */}
				<Link
					href="/upload"
					className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-[#FF7F4F] text-white shadow-lg transition-transform hover:scale-110"
					title="Get Quote"
					aria-label="Get quote"
				>
					<FileText size={iconSize} weight="duotone" />
				</Link>
				{/* 邮箱 - 蓝色，mailto 唤起默认邮箱客户端 */}
				<a
					href={`mailto:${contactInfo.email}`}
					className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-[#5F9FFF] text-white shadow-lg transition-transform hover:scale-110"
					title="Email"
					aria-label="Send email"
				>
					<EnvelopeSimple size={iconSize} weight="duotone" />
				</a>
				{/* WhatsApp - 绿色 */}
				<a
					href={WHATSAPP_URL}
					target="_blank"
					rel="noopener noreferrer"
					className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-[#4CAF50] text-white shadow-lg transition-transform hover:scale-110"
					title="WhatsApp"
					aria-label="Chat on WhatsApp"
				>
					<WhatsappLogo size={iconSize} weight="duotone" />
				</a>
			</div>

			{/* 移动端：底部全宽栏（Home、Quote、Email、WhatsApp），仅 md 以下显示 */}
			<div className="safe-area-pb fixed bottom-0 left-0 right-0 z-50 flex items-center justify-around border-t border-gray-200 bg-white py-3 shadow-[0_-4px_12px_rgba(0,0,0,0.08)] md:hidden">
				<Link
					href="/"
					className="hover:text-themePrimary400 flex min-w-0 flex-1 flex-col items-center gap-1 text-gray-600 transition-colors"
					aria-label="Home"
				>
					<House size={24} weight="duotone" />
					<span className="text-xs font-medium">Home</span>
				</Link>
				<Link
					href="/upload"
					className="hover:text-themePrimary400 flex min-w-0 flex-1 flex-col items-center gap-1 text-gray-600 transition-colors"
					aria-label="Quote"
				>
					<FileText size={24} weight="duotone" />
					<span className="text-xs font-medium">Quote</span>
				</Link>
				<a
					href={`mailto:${contactInfo.email}`}
					className="hover:text-themePrimary400 flex min-w-0 flex-1 flex-col items-center gap-1 text-gray-600 transition-colors"
					aria-label="Email"
				>
					<EnvelopeSimple size={24} weight="duotone" />
					<span className="text-xs font-medium">Email</span>
				</a>
				<a
					href={WHATSAPP_URL}
					target="_blank"
					rel="noopener noreferrer"
					className="hover:text-themePrimary400 flex min-w-0 flex-1 flex-col items-center gap-1 text-gray-600 transition-colors"
					aria-label="WhatsApp"
				>
					<WhatsappLogo size={24} weight="duotone" />
					<span className="text-xs font-medium">WhatsApp</span>
				</a>
			</div>
		</>
	);
}
